module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/text_gray01-81109c363def2b06f867324b3df66d31.png";